import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFocusEffect, useNavigation, useRoute } from '@react-navigation/native';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { DashboardScope } from '@api/domain/types';
import { selectDashboardScope, setDashboardScope } from '@reducers/v2/dashboard/dashboard.slice';
import { DashboardOverviewScreenName } from '@v2/pages/dashboard/navigation/config';

export const useManageDashboardShowAllHeader = () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigation<any>();
  const route = useRoute<any>();
  const scope = useSelector(selectDashboardScope);

  const onSelectScope = useCallback(
    (next: DashboardScope) => {
      dispatch(setDashboardScope(next));
      navigation.setParams({ scope: next });
    },
    [dispatch, navigation]
  );

  const onBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate(DashboardOverviewScreenName as never);
    }
  }, [navigation]);

  useFocusEffect(
    useCallback(() => {
      const urlScope = route.params?.scope as DashboardScope | undefined;
      if (urlScope && Object.values(DashboardScope).includes(urlScope)) {
        if (urlScope !== scope) dispatch(setDashboardScope(urlScope));
      } else {
        navigation.setParams({ scope });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [route.params?.scope])
  );

  return { scope, onSelectScope, onBack };
};
